import { Invoice, ModuleDefinition, OrganisationModules, Plan } from "@utilities/types";
import { createContext, useState, PropsWithChildren, FC } from "react";

interface SubscriptionContextType {
    plans: Plan[]
    setPlans: (plans: Plan[]) => void;
    modules: ModuleDefinition[];
    setModules: (modules: ModuleDefinition[]) => void;
    organisationModules: OrganisationModules | null;
    setOrganisationModules: (modules: OrganisationModules | null) => void;
    nextInvoice: Invoice | null;
    setNextInvoice: (invoice: Invoice | null) => void;
    InvoiceHistory: Invoice[];
    setInvoiceHistory: (invoices: Invoice[]) => void;
}

export const SubscriptionContext = createContext<SubscriptionContextType>({
    plans: [],
    setPlans: () => {},
    modules: [],
    setModules: () => {},
    organisationModules: null,
    setOrganisationModules: () => {},
    nextInvoice: null,
    setNextInvoice: () => {},
    InvoiceHistory: [],
    setInvoiceHistory: () => {}
});

export const SubscriptionContextProvider: FC<PropsWithChildren> = ({ children }) => {

    const [plans, setPlans] = useState<Plan[]>([]);
    const [modules, setModules] = useState<ModuleDefinition[]>([]);
    const [organisationModules, setOrganisationModules] = useState<OrganisationModules | null>(null);
    const [nextInvoice, setNextInvoice] = useState<Invoice | null>(null);
    const [InvoiceHistory, setInvoiceHistory] = useState<Invoice[]>([]);

    return (
        <SubscriptionContext.Provider
            value={{
                plans, setPlans,
                modules, setModules,
                organisationModules, setOrganisationModules,
                nextInvoice, setNextInvoice,
                InvoiceHistory, setInvoiceHistory
            }}
        >
            {children}
        </SubscriptionContext.Provider>
    );
};
